<template>
  <div>
    <Overlay
      :position="'absolute'"
      :open="loading"
      :color="''"
      :maxOpacity="1"
      :classes="'loader'"
    >
      <div v-if="loading">
        <!-- Loader content if needed -->
      </div>
    </Overlay>

    <div v-if="isDisplayApp" class="container px-0 reviewsApp">
      <Reviews />
    </div>
  </div>
</template>

<script setup>
import { computed, onMounted } from 'vue'
import { useStore } from 'vuex'

// components
import Reviews from '@/vue/reviews-translation/components/reviews.vue'
import Overlay from '@/vue/common/overlay.vue'

// store
const store = useStore()

const loading = computed(() => store.state.loading)
const ssrReviewData = computed(() => store.state.ssrReviewData)

const isDisplayApp = computed(() => {
  return ssrReviewData.value?.reviews?.length > 0
})

onMounted(() => {
  if (!isDisplayApp.value) {
    const ssrEl = document.querySelector('#reviews-ssr')
    if (ssrEl) ssrEl.remove()
  }
  store.commit('setScreenType', window.screenSizeManager.screenType)
  window.addEventListener('screenTypeChange', () => {
    store.commit('setScreenType', window.screenSizeManager.screenType)
  })
})
</script>

<style>
.loading-gif {
  width: 150px;
  height: 150px;
}

.shadow-lighter-blue--hover-effect {
  transition: box-shadow 100ms ease-in-out;
}
.shadow-lighter-blue--hover-effect:hover {
  /* Custom hover effect - using design system blue-600 as closest match */
  box-shadow: 0px 0px 6px 0px var(--blue-600) !important;
}
</style>
